export enum VideoRequestsPageEventType {
  DVR = 'DVRUpload',
  PANIC_BUTTON = 'Custom-Triggered',
  EDVR = 'edvr',
}

export interface VideoRequestsPageQueryParams {
  startTimeUTC?: string;
  endTimeUTC?: string;
  eventType?: VideoRequestsPageEventType;
  tripId?: string;
  driverId?: string;
  eventIndex?: string;
  uploadRequestId?: string;
}

export interface IncidentDetailsParams {
  tripId: string;
  driverId: string;
  eventIndex: number;
}

export interface SafetyEventsPageQueryParams {
  startTimeUTC?: string;
  endTimeUTC?: string;
  eventType?: string;
  tripId?: string;
  driverId?: string;
  eventIndex?: string;
}

export interface DiagnosticsQueryParams {
  tab?: string;
  subTab?: string;
  eventType?: string;
  deviceId?: string;
}

export const AllowedPaths = {
  safetyEvents: '/safety-events',
  videoRequests: '/video-requests',
  assets: '/assets',
  tripDetails: '/trip-details',
};
